module.exports = __webpack_public_path__ + "static/media/bean-bowl.953cb45e.png";